import(/* webpackMode: "eager", webpackExports: ["IntegrationsGrid"] */ "/tmp/8de8b74867a3b99/components/sections/IntegrationsGrid.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/8de8b74867a3b99/components/ui/Section.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de8b74867a3b99/components/ui/Container.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de8b74867a3b99/components/ui/Text.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de8b74867a3b99/node_modules/next/dist/client/link.js");
